export default "__VITE_ASSET__BBr6r9FG__"